import * as types from '../mutation-types';
import UserPhoneCredentials from '../../api/userPhoneCredentials';

const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getCredentials: $state => {
    return $state.record;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_USER_PHONE_CREDENTIALS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await UserPhoneCredentials.get();
      commit(types.default.SET_USER_PHONE_CREDENTIALS, response.data);
    } finally {
      commit(types.default.SET_USER_PHONE_CREDENTIALS_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  update: async ({ commit }, { username, password }) => {
    commit(types.default.SET_USER_PHONE_CREDENTIALS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await UserPhoneCredentials.update({
        phone_credentials: { username, password },
      });
      commit(types.default.SET_USER_PHONE_CREDENTIALS, response.data);
    } finally {
      commit(types.default.SET_USER_PHONE_CREDENTIALS_UI_FLAG, {
        isUpdating: false,
      });
    }
  },

  updateFromWebsocket: ({ commit, state: $state, rootGetters }, data) => {
    if (!data.queue_status) return;
    const currentUserId = rootGetters.getCurrentUser?.id;
    if (!currentUserId || data.user_id !== currentUserId) return;
    if (!$state.record?.id) return;

    commit(
      types.default.UPDATE_USER_PHONE_CREDENTIALS_QUEUE_STATUS,
      data.queue_status
    );
  },
};

export const mutations = {
  [types.default.SET_USER_PHONE_CREDENTIALS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_USER_PHONE_CREDENTIALS]: ($state, data) => {
    $state.record = data;
  },
  [types.default.UPDATE_USER_PHONE_CREDENTIALS_QUEUE_STATUS]: (
    $state,
    queueStatus
  ) => {
    const existing = $state.record.queue_status || [];
    const index = existing.findIndex(qs => qs.number === queueStatus.number);
    const updated =
      index >= 0
        ? existing.map((qs, i) => (i === index ? queueStatus : qs))
        : [...existing, queueStatus].sort((a, b) =>
            a.number.localeCompare(b.number)
          );
    $state.record = { ...$state.record, queue_status: updated };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
